import { defineMessage } from 'services/localization';

export const messages = {
    airwallexBatchPaymentBills: defineMessage('airwallex_batch_payment_bills'),
    total: defineMessage('total_2'),
    items: defineMessage('bill'),
    date: defineMessage('date'),
    paymentMethod: defineMessage('payment_method'),
    sourceCurrency: defineMessage('source_currency'),
    amountDue: defineMessage('amount_due'),
    paymentAmount: defineMessage('payment_amount'),
    purpose: defineMessage('purpose'),
    paymentReference: defineMessage('reference'),
    xeroBankAccount: defineMessage('xero_bank_account'),
    beneficiary: defineMessage('beneficiary'),
    billCurrency: defineMessage('bill_currency'),
    attachments: defineMessage('attachments'),
    dueDate: defineMessage('due_date'),
    fee: defineMessage('fee'),
    amount: defineMessage('amount'),
    sourceCurrencyAmount: defineMessage('amountbrsourcebrcurrency'),
    feeAmount: defineMessage('fee'),
    airwallexPayment: defineMessage('airwallex_payment'),
    openInAirwallex: defineMessage('open_in_airwallex'),
    xeroPayment: defineMessage('xero_payment'),
    paymentStatus: defineMessage('status_1'),
    att: defineMessage('att'),
    openInXero: defineMessage('open_in_xero'),
    links: defineMessage('links'),
    bankDetailsChanged: defineMessage('bank_details_have_changed'),
};
